// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router.map'
import firebase from 'firebase'
import axios from 'axios'
import store from './store'

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

function requestToken () {
  return new Promise((resolve, reject) => {
    store.dispatch('autenticacaoUsuario', { user: localStorage.getItem('usuario'), password: localStorage.getItem('password') }).then((response) => {
      console.log('sucesso login => ', response)
      resolve();
    }).catch((responseError) => {
      // let erro = responseError.data.message;
      console.log('erro login => ', JSON.stringify(responseError));
      localStorage.setItem('token', 'false')
      resolve()
      // store.dispatch('logout').then(() => {
      //   reject();
      // });
    })
  })
}

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(async function (user) {
    // var user = firebase.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (user != null && localStorage.getItem('password') && localStorage.getItem('usuario')) {
      let response = JSON.parse(localStorage.getItem('response'))
      let indexEmpresa = store.state.empresa_ativa !== null && !isNaN(store.state.empresa_ativa) ? store.state.empresa_ativa : 0
      if (response !== null && response.Empresas[indexEmpresa].modulos) {
        // console.log('indexEmpresa-> ', indexEmpresa)
        store.commit('SET_EMPRESAS', response.Empresas)
        store.commit('SET_EMPRESA_ID', response.Empresas[indexEmpresa].id)
        store.commit('SET_EMPRESA', response.Empresas[indexEmpresa].nome)
        store.commit('SET_API', response.Empresas[indexEmpresa].api)
        store.commit('SET_LOGO', response.Empresas[indexEmpresa].logo)
        store.commit('SET_APIBOT', response.Empresas[indexEmpresa].api_bot)
        store.commit('SET_USERNAME', response.nome_usuario)
        store.commit('SET_FULLNAME', response.nome_completo)
        store.commit('SET_EMAIL', response.email)
        store.commit('SET_FOTO', response.url_foto)
        store.commit('SET_INDEXEMPRESA', indexEmpresa)
        store.commit('SET_TOKEN', response.Empresas[indexEmpresa].fb_page_token)
        store.commit('SET_PERMITE_IMPRESSAO', response.permite_impressao)
        store.commit('SET_PERMITE_EMAIL', response.permite_email)
        store.commit('SET_FB_ID_EMPRESA', response.Empresas[indexEmpresa].fb_id)
        store.commit('SET_MODULOS_EMPRESA', response.Empresas[indexEmpresa].modulos)
        document.title = response.Empresas[indexEmpresa].nome
        
        if(!localStorage.getItem('token')) {
          requestToken().then(() => {
            next()
          }).catch(err => {
            location.reload()
          })
        } else {
          console.log(localStorage.getItem('token'))
          console.log(response.Empresas[indexEmpresa].api.indexOf('dev-chatlivery'))
          if(localStorage.getItem('token') === 'false' && response.Empresas[indexEmpresa].api.indexOf('dev-chatlivery') != -1) {
            console.log('precisa de token***********')
            requestToken().then(() => {
              next()
            }).catch(err => {
              location.reload()
            })
          } else {
            console.log('nao precisa de token***********')

            next()
          }
        }
      } else {
        let url = 'https://sev-delivery.herokuapp.com/api/usuarios'
        axios.post(url, {
          'email': user.email
        }).then(async response => {
          console.log('response-> ', response)
          // indexEmpresa = !isNaN(store.state.empresa_ativa) ? store.state.empresa_ativa : 0
          store.commit('SET_EMPRESAS', response.data.Empresas)
          store.commit('SET_EMPRESA_ID', response.data.Empresas[indexEmpresa].id)
          store.commit('SET_EMPRESA', response.data.Empresas[indexEmpresa].nome)
          store.commit('SET_API', response.data.Empresas[indexEmpresa].api)
          store.commit('SET_LOGO', response.data.Empresas[indexEmpresa].logo)
          store.commit('SET_APIBOT', response.data.Empresas[indexEmpresa].api_bot)
          store.commit('SET_USERNAME', response.data.nome_usuario)
          store.commit('SET_FULLNAME', response.data.nome_completo)
          store.commit('SET_EMAIL', response.data.email)
          store.commit('SET_FOTO', response.data.url_foto)
          store.commit('SET_INDEXEMPRESA', indexEmpresa)
          store.commit('SET_TOKEN', response.data.Empresas[indexEmpresa].fb_page_token)
          store.commit('SET_PERMITE_IMPRESSAO', response.data.permite_impressao)
          store.commit('SET_PERMITE_EMAIL', response.data.permite_email)
          store.commit('SET_FB_ID_EMPRESA', response.data.Empresas[indexEmpresa].fb_id)
          store.commit('SET_MODULOS_EMPRESA', response.data.Empresas[indexEmpresa].modulos)
          localStorage.setItem('response', JSON.stringify(response.data))
          document.title = response.data.Empresas[indexEmpresa].nome

          if(!localStorage.getItem('token')) {
            requestToken().then(() => {
              next()
            }).catch(err => {
              console.log('erro token ==> ', err)
              alert('Erro ao obter token');
              location.reload()
            })
          } else {
            next()
          }

        })
      }
    } else if (!requiresAuth) {
      next()
    } else next('login')
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router.js